import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../../../../../src/helpers/reselectHelpers';
import {popoutContactDetailsAction} from '../../../../../../../../src/store/panels/contacts/contactDetailsPanelActions';
import {CreateContactFormFieldModel} from '../../../../../../../../src/store/panels/contacts/createContactForm/createContactFormState';
import {ContactsManagerPanelId} from '../../../../../../../../src/store/panels/panelStateBase';
import {CreateContactInformationFormFieldError} from './createContactInformationFormFieldError';

/*
 * Props.
 */

interface CreateContactInformationFormFieldErrorContainerProps {
  panelId: ContactsManagerPanelId;
  formField: CreateContactFormFieldModel;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<CreateContactInformationFormFieldErrorContainerProps>()(
  ({panelId, formField}) => ({
    openContactDetailsPopup: () =>
      popoutContactDetailsAction({
        parentPanelId: panelId,
        selectedCardId: formField.duplicateCardId,
        shouldHideHeaderTabs: true,
      }),
  }),
);

export const CreateContactInformationFormFieldErrorContainer = connect(
  null,
  mapDispatchToProps,
)(CreateContactInformationFormFieldError);
